export default __webpack_public_path__ + "static/media/screenshot0.70cd25fc.jpg";